import { linearGradient } from '../../../../internal/styles/linearGradient';
import { type BannerBoxTokens } from '../types';

export const bannerBox: BannerBoxTokens = {
  colors: {
    borderTop: '#338695',
    background: '#40a1b3',
    background2: '#198cfb',
    background5: '#00A7CC',
  },
  backgroundImage: {
    base: null,
    gradient: linearGradient('90deg', ['primary.90', 'primary.70']),
  },
};
